import React from "react"
import ReactDOM from "react-dom/client"
import { Provider } from "react-redux"
import { BrowserRouter } from "react-router-dom"

import { store } from "./core/app/store"
import App from "./App"
import { loadAWSRUMClient, getAWSRUMClient } from "./core/global/awsRumClient"
import "./index.scss"
import oktaAuthClient from "./core/config/okta.config"

// filter the ignorable errors
const originalConsoleError = console.error;
const errFilterList = [
  "Support for defaultProps will be removed",
]

oktaAuthClient.authStateManager.subscribe((authState) => {
  loadAWSRUMClient(oktaAuthClient.getAccessToken())
})

window.onerror = function (message, source, lineno, colno, error) {
  if (message && typeof message=== 'string' && message.includes(`unwind`)) {
    return
  }
  getAWSRUMClient()?.recordError(error || message);
};

window.onunhandledrejection = function (event) {
  getAWSRUMClient()?.recordError(event.reason);
};


console.error = (...args) => {
  try {
    const errorMessage = args.map(arg => {
      if (arg instanceof Error) return arg.stack || arg.message;
      if (typeof arg === 'object') return JSON.stringify(arg);
      return String(arg);
    }).join(' ');
  
    if (errorMessage  && errorMessage.includes(`unwind`)) {
      return
    }

    getAWSRUMClient()?.recordError({
        message: errorMessage,
        metadata: { consoleArgs: args },
      });
    if (args.length > 0 && typeof args[0] === "string") {
      const shouldSuppress = errFilterList.some((filter) => args[0].includes(filter));
      if (!shouldSuppress) {
        originalConsoleError(...args);
      }
    } else {
      originalConsoleError(...args);
    }
  } catch (error) {
    // Error in custom console.error override
    originalConsoleError(...args);
  }
};

const contentElement = document.getElementById("root") as HTMLElement

ReactDOM.createRoot(contentElement).render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
)
